import React from "react";
import Chart from "react-apexcharts";

const ReusableChart = ({ options, series }) => {
  return <Chart options={options} series={series} type="bar" />;
};

export default ReusableChart;
